{
  "deselectedItem": "{item} не вибрано.",
  "select": "Вибрати",
  "selectedAll": "Усі елементи вибрано.",
  "selectedCount": "{count, plural, =0 {Жодних елементів не вибрано} one {# елемент вибрано} other {Вибрано елементів: #}}.",
  "selectedItem": "{item} вибрано."
}
